<template>
	<auth-shell>
		<template v-if="!info">
			<h1 class="auth-title">Set your password</h1>
			<p class="auth-subtitle">Create a password to activate your Mission Control account.</p>

			<form @submit.prevent="sendResetPasswordLink">
				<div class="auth-field">
					<label class="auth-label" for="password">Password</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'lock']" />
						<input
							id="password"
							:type="showPassword ? 'text' : 'password'"
							class="auth-input auth-input--has-toggle"
							placeholder="Create a password"
							autocomplete="new-password"
							v-model="password"
							required
						/>
						<button
							type="button"
							class="auth-input-toggle"
							:aria-label="showPassword ? 'Hide password' : 'Show password'"
							@click="showPassword = !showPassword"
						>
							<font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
						</button>
					</div>
				</div>

				<div class="auth-field">
					<label class="auth-label" for="confirmPassword">Confirm password</label>
					<div class="auth-input-group">
						<font-awesome-icon class="auth-input-icon" :icon="['fas', 'lock']" />
						<input
							id="confirmPassword"
							:type="showConfirm ? 'text' : 'password'"
							class="auth-input auth-input--has-toggle"
							placeholder="Re-enter your password"
							autocomplete="new-password"
							v-model="confirmPassword"
							required
						/>
						<button
							type="button"
							class="auth-input-toggle"
							:aria-label="showConfirm ? 'Hide password' : 'Show password'"
							@click="showConfirm = !showConfirm"
						>
							<font-awesome-icon :icon="['fas', showConfirm ? 'eye-slash' : 'eye']" />
						</button>
					</div>
				</div>

				<button v-if="!loading" type="submit" class="auth-btn">
					Set password
					<font-awesome-icon :icon="['fas', 'arrow-right']" />
				</button>
				<button v-else type="button" class="auth-btn" disabled>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					Setting your password…
				</button>
			</form>
		</template>

		<div v-else class="auth-success">
			<div class="auth-success__icon"><font-awesome-icon :icon="['fas', 'check-circle']" /></div>
			<h1 class="auth-title">You're all set</h1>
			<p class="auth-subtitle">Your password has been saved. You can now sign in to your account.</p>
			<router-link class="auth-btn" to="/login" style="text-decoration:none">
				Continue to sign in
				<font-awesome-icon :icon="['fas', 'arrow-right']" />
			</router-link>
		</div>
	</auth-shell>
</template>
<script>
import AuthShell from '../../components/auth/AuthShell.vue'
import restApi from '../../api'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'SetPassword',
	components: { AuthShell },
	data() {
		return {
			info: '',
			email: '',
			password: '',
			confirmPassword: '',
			passwordToken: '',
			loading: false,
			showPassword: false,
			showConfirm: false,
		}
	},
	created() {
		this.passwordToken = this.$route.query.token
		this.email = this.$route.query.email
	},
	methods: {
		async sendResetPasswordLink() {
			this.loading = true
			restApi
				.post(`/reset-password`, {
					email: this.email,
					password: this.password,
					password_confirmation: this.confirmPassword,
					passwordToken: this.passwordToken,
				})
				.then(
					({ data }) => {
						this.info = data.message
						this.loading = false
					},
					error => {
						this.info = ''
						this.$swal.fire({
							icon: 'error',
							title: handleErrors(error, 'resetPassword'),
							timer: 6000,
						})
						this.loading = false
					}
				)
		},
	},
}
</script>
